var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleDialogue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 84,
    viewBox: "0 0 113 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6384_34778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.6562,
    y: 26.3438,
    width: 1,
    height: 17,
    transform: "rotate(-45 25.6562 26.3438)",
    fill: "#5D38F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3633,
    y: 38.3633,
    width: 1,
    height: 17,
    transform: "rotate(-135 26.3633 38.3633)",
    fill: "#5D38F7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#5D38F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6384_34778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0956 56.0586C80.0956 54.896 80.2828 53.9265 80.6572 53.1503C81.0307 52.3741 81.7999 51.5005 82.9649 50.5294C83.7741 49.8311 84.3833 49.1689 84.7923 48.5426C85.2014 47.9164 85.406 47.2105 85.406 46.425C85.406 45.2954 84.9978 44.3548 84.1814 43.6032C83.365 42.8524 82.2494 42.477 80.8346 42.477C79.6839 42.477 78.767 42.7321 78.084 43.2422C77.4011 43.7523 76.8519 44.387 76.4366 45.1463L75 44.5057C75.57 43.4269 76.3321 42.5728 77.2863 41.9431C78.2405 41.3144 79.4233 41 80.8346 41C82.8088 41 84.3304 41.5381 85.3993 42.6143C86.4682 43.6905 87.0018 44.9505 87 46.3945C87 47.3241 86.787 48.1728 86.361 48.9405C85.9342 49.7091 85.3117 50.4395 84.4935 51.1318C83.2681 52.1606 82.4958 52.9995 82.1765 53.6486C81.8582 54.2977 81.699 55.1006 81.699 56.0573L80.0956 56.0586ZM80.8373 63C80.4798 63 80.1681 62.8733 79.9022 62.6199C79.6354 62.3666 79.502 62.0696 79.502 61.7289C79.502 61.3883 79.6354 61.0912 79.9022 60.8379C80.169 60.5845 80.4802 60.4578 80.8359 60.4578C81.1916 60.4578 81.5038 60.5845 81.7723 60.8379C82.0409 61.0912 82.1739 61.3883 82.1712 61.7289C82.1685 62.0696 82.0351 62.3666 81.771 62.6199C81.5069 62.8733 81.1956 63 80.8373 63Z",
    fill: "#C691FB"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 20.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#C691FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6384_34778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6384_34778"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDialogue);
export default __webpack_public_path__ + "static/media/double_dialogue.8ce9eb055d14b2abc7810c5fb972eaf0.svg";
export { ForwardRef as ReactComponent };